import 'core-js'
import 'es6-promise'
import 'isomorphic-fetch'
import 'raf'
import 'object-assign'



// WEBPACK FOOTER //
// ./src/polyfill.ts